import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import _get from 'lodash/get';
import { authSelectors, environmentSelectors } from '@lifesize/nucleus';
import UpgradeButton from 'components/Header/UpgradeButton';
import lsConfig from 'utils/global-config';
import { getShopUrl } from 'utils/UrlUtil';

const mapStateToProps = (state) => {
  const jwt = authSelectors.getPrimaryJwt(state);
  const upgradeURL = getShopUrl(jwt);
  const isDesktop = environmentSelectors.platform(state).isDesktop;
  const sendToShop = () => {
    lsConfig.skipTimeOnBeforeUnload(1000);
    if (isDesktop) {
      window.open(upgradeURL);
    } else {
      window.location.href = upgradeURL;
    }
  };

  return {
    sendToShop,
    showUpgrade: _get(state, 'app.flags.displayUpgradeLink', false)
  };
};

export default injectIntl(connect(mapStateToProps)(UpgradeButton));
